import { ErrorLayout } from "@components/ErrorBoundary/ui/ErrorLayout";

export const NotFoundPage = () => (
  <ErrorLayout title="404 Error" code="404" description="Page not found" />
);
